import * as rudderanalytics from "rudder-sdk-js";
import EnvConfig from "../../config/EnvConfig";
rudderanalytics.load(EnvConfig.rudderWriteKey, EnvConfig.rudderDataPlaneUrl);
export { rudderanalytics as RudderStack };

